import api from './api';

export const getSystemHealth = async () => {
  const response = await api.get('/system/health');
  return response.data;
};

export const getSystemLogs = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/system/logs?${queryParams}`);
  return response.data;
};
